export default __webpack_public_path__ + "static/media/magnatab-lowercase.8dc4d360.jpg";